<template>
    <b-container fluid class="overview" v-if="!loading">
        <h1 class="text-left">
            {{ $t('dashboard.dashboardAlerts.alertBoxTitle') }}
        </h1>
        <div v-if="hasNoErrors">
            {{ $t('dashboard.dashboardAlerts.noErrors') }}
        </div>
        <div v-else>
            <div v-if="hasLayerErrors">
                <br />
                <b-table
                    id="domainoverviewtable"
                    striped
                    hover
                    small
                    outlined
                    bordered
                    caption-top
                    :items="layerErrors"
                    :fields="fields"
                    sort-by.sync="startTime"
                    sort-icon-left
                >
                    <template #table-caption>
                        <h4>
                            {{ $t('dashboard.dashboardAlerts.layerErrors') }}
                        </h4>
                    </template>
                    <!-- Custom cell slot for other users -->
                    <template #cell(themeLayerErrorUsers)="data">
                        <ul>
                            <li
                                v-for="(
                                    themeLayerErrorUser, index
                                ) in data.item.themeLayerErrorUsers.slice(
                                    0,
                                    maxUsers
                                )"
                                :key="index"
                            >
                                {{ $_getAlsoByString(themeLayerErrorUser) }}
                            </li>
                        </ul>
                        <!-- Optionally, display a message if there are more items -->
                        <div
                            v-if="
                                data.item.themeLayerErrorUsers.length > maxUsers
                            "
                        >
                            {{
                                $t('dashboard.dashboardAlerts.andMore', [
                                    data.item.themeLayerErrorUsers.length -
                                        maxUsers
                                ])
                            }}
                        </div>
                    </template>
                    <!-- Custom slot for SourceName -->
                    <template #cell(sourceName)="data">
                        <a
                            :href="`/dashboard/ows/detail/${data.item.sourceId}`"
                            :title="$t('dashboard.dashboardAlerts.goToOwsPage')"
                        >
                            {{ data.item.sourceName }}
                        </a>
                    </template>
                </b-table>
            </div>
        </div>
        <div class="sticky-bottom fixed-bottom">
            <div class="btn-group">
                <b-button
                    id="refresh_button"
                    variant="primary"
                    class="d-flex align-items-center"
                    :disabled="loading"
                    @click="$_refresh()"
                >
                    {{ $t('dashboard.dashboardAlerts.refresh') }}
                </b-button>
            </div>
        </div>
    </b-container>
</template>
<script>
    import { nprogress } from '../../services/utilities';
    export default {
        data() {
            return {
                loading: true, // prevent showing "no errors" before loading has completed
                layerErrors: [], // This will store themeLayerErrors
                maxUsers: 5, // Maximum number of "also by" users
                fields: [
                    {
                        key: 'startTime',
                        label: this.$t('dashboard.dashboardAlerts.startTime'),
                        sortable: true,
                        formatter: (value) => {
                            return this.$_getDateString(value);
                        }
                    },
                    {
                        key: 'sourceName',
                        label: this.$t('dashboard.dashboardAlerts.sourceName'),
                        sortable: true
                    },
                    {
                        key: 'layerName',
                        label: this.$t('dashboard.dashboardAlerts.layerName'),
                        sortable: true
                    },
                    {
                        key: 'userName',
                        label: this.$t('dashboard.dashboardAlerts.userName'),
                        sortable: true
                    },
                    {
                        key: 'problemMessage',
                        label: this.$t('dashboard.dashboardAlerts.problemMessage'),
                        sortable: true
                    },
                    {
                        key: 'themeLayerErrorUsers',
                        label: this.$t('dashboard.dashboardAlerts.otherUsers'),
                        sortable: true
                    }
                ]
            };
        },
        computed: {
            hasLayerErrors() {
                return this.layerErrors && this.layerErrors.length > 0;
            },
            hasNoErrors() {
                return !this.hasLayerErrors;
            }
        },
        methods: {
            // Method to call the API
            async $_fetchData() {
                nprogress.start();
                const result = await this.$store.dispatch('useApiData', {
                    name: 'GetThemeLayerErrors'
                });
                this.layerErrors = result.data;

                this.loading = false;
                nprogress.done();
            },
            $_getDateString(dateValue) {
                return new Date(dateValue).toLocaleString(
                    this.$store.state.userInfo.locale
                );
            },
            $_getAlsoByString(themeLayerErrorUser) {
                return `${themeLayerErrorUser.userName} om ${this.$_getDateString(
                    themeLayerErrorUser.startTime
                )}`;
            },
            $_refresh() {
                this.loading = true;
                this.$_fetchData();
            }
        },
        async mounted() {
            // Start polling when the component is mounted
            await this.$_fetchData();
        }
    };
</script>

